<template>
    <div id="PublicationSection">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                    <h5 class="card-title flex-grow-1 mb-0">Publications</h5>
                    <div class="flex-shrink-0">
                        <button @click="formContext.modal = true" class="btn btn-primary" type="button">
                            Add <span class="d-none d-sm-inline">Publication</span>
                        </button>
                    </div>
                </div>

                <CommonSpinner v-if="isLoading" />

                <div v-else class="row g-4">
                    <div v-for="(publication,index) in pageData.data" :key="index" class="col-lg-6">
                        <div class="card border mb-0">
                            <div class="card-body p-3">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <span class="badge bg-primary mb-2">{{ $filters.textFromSlug(publication.type) }}</span>
                                        <h5 class="mb-2">{{ publication.title }}</h5>

                                        <p class="mb-1" v-if="publication.authors">
                                            <strong>Authors:</strong> {{ publication.authors }}
                                        </p>
                                        <p class="mb-1" v-if="publication.publisher">
                                            <strong>Publisher:</strong> {{ publication.publisher }}
                                        </p>
                                        <p class="mb-1" v-if="publication.publication_year">
                                            <strong>Year:</strong> {{ publication.publication_year }}
                                        </p>
                                        <div v-if="publication.pdf_path" class="mt-3 d-flex">
                                            <img width="50" class="me-3" :src="absoluteUrl('/images/file-icons/pdf.svg')"/>
                                            <div>
                                                <small class="text-muted d-block">Attached PDF File</small>
                                                <button @click.prevent="showPdfModal(publication.pdf_path)" type="button" class="btn btn-link p-0">View PDF</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dropdown dropstart no-arrow">
                                        <button class="dropdown-toggle btn btn-sm rounded-circle btn-primary" type="button" data-bs-toggle="dropdown">
                                            <i class="ri-more-2-fill"></i>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <button @click.prevent="openEditView(publication)" class="dropdown-item">
                                                    Edit
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="!pageData.data.length">No publications added.</p>
                </div>
            </div>
        </div>
        <b-modal
            v-model="formContext.modal"
            size="lg"
            centered
            hide-footer
            title-class="fs-6"
            :title="formContext.editMode ? 'Update Publication' : 'Add Publication'"
            @hide="closeEditView()">
            <publication-form
                v-if="formContext.modal"
                :edit-mode="formContext.editMode"
                :edit-item="formContext.item"
                @closeMe="closeEditView()"
                @addedItem="addItem"
                @updatedItem="updateItem"/>
        </b-modal>
    </div>
</template>

<script>
import PublicationForm from "@/components/forms/PublicationForm.vue";
import { commonEditViewMixin } from "@/mixins/commonEditViewMixin";
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components:{
        PublicationForm
    },
    mixins:[
        commonEditViewMixin,
        commonPaginationMixin
    ],
    data(){
        return{
            isLoading:false,
        }
    },
    methods:{
        addItem(item){
            this.pageData.data.unshift(item);
        },
        updateItem(item){
            const index = this.pageData.data.findIndex(i=>i.id==item.id);
            Object.assign(this.pageData.data[index],item);
        },
        fetchItems(){
            this.isLoading = true;
            this.$http.get("/publications")
            .then(response => {
                this.isLoading = false;
                if(response.data.success){
                    this.pageData = response.data.data;
                }
            });
        },
        showPdfModal(item) {
            let filePath = this.absoluteUrl(item);
            this.$store.commit('TOGGLE_PDF_MODAL_FRAME', { visible: true, filePath: filePath})
        },
    },
    created(){
        this.fetchItems();
    }
}
</script>